/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  maxWidth,
  primaryColor,
  primaryFont, primaryHeadingColor, retina, wLight, wMedium,
} from 'Utils/utilsStyle';
import { Input } from 'antd';
import React from 'react';
import styled from 'styled-components';

const SmartInputWrapper = styled.div`
.ant-input {
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 16px;
  line-height: 22px;
  color: ${primaryHeadingColor};
  border-radius: 8px;
  resize: none;
  @media all and (max-width: ${maxWidth}),${retina} {
    font-size: 14px;
  }
  ::placeholder {
    font-family: ${primaryFont};
    font-weight: ${wLight};
    font-style: italic;
    font-size: 16px;
    line-height: 22px;
    color: #C7C7C7;
     @media all and (max-width: ${maxWidth}),${retina} {
      font-size: 14px;
    }
  }
  :hover,:focus {
    box-shadow: none;
    border-color: ${primaryColor};
  }
  ::-webkit-scrollbar { width: 17px; } ::-webkit-scrollbar-track { background-color: transparent; } ::-webkit-scrollbar-thumb { background-color: #001760; border-radius: 20px; border: 7px solid transparent; background-clip: content-box; }
}
grammarly-extension {
  display: none;
}
.mb-15 {
  margin-bottom: 15px;
}
`;

type Props = {
  value: string | string[],
  handleInputChange: (a: string, b?: number) => void,
  handleKeyDown?: (a: React.KeyboardEvent<HTMLTextAreaElement>, b: number) => void,
  inputRef?: (ref: HTMLTextAreaElement | null) => void;
  placeholderText?: string,
  noOfRows?: number,
  multiInput?: boolean,
} & typeof defaultProps;

const defaultProps = {
  placeholderText: '',
  noOfRows: 2,
  multiInput: false,
  handleKeyDown: (a: React.KeyboardEvent<HTMLTextAreaElement>) => { },
  inputRef: (ref: HTMLTextAreaElement | null) => { },
};

const SmartInput = function SmartInput(props: Props) {
  const {
    value, handleInputChange, placeholderText, noOfRows, handleKeyDown, inputRef, multiInput,
  } = props;

  return (
    <SmartInputWrapper className="smart-account-input">
      {noOfRows === 1 && !multiInput
        ? (
          <Input
            placeholder={placeholderText}
            className="text-area-smart noskip"
            value={value}
            tabIndex={-1}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        )
        : (
          <Input.TextArea
            placeholder={placeholderText}
            className="text-area-smart noskip"
            value={value}
            rows={noOfRows}
            tabIndex={-1}
            onChange={(e) => handleInputChange(e.target.value)}
            onKeyDown={handleKeyDown}
            ref={inputRef}
          />
        )}
    </SmartInputWrapper>
  );
};
SmartInput.defaultProps = defaultProps;
export default SmartInput;
